import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import iconsMixin from '../../core/dtwin/state/bridge/iconsMixin';
import { isEqual } from 'lodash';
var SUBJECT_EN = '{{exportTitle}} - created at: {{exportDate}}';
var SUBJECT_DE = '{{exportTitle}} - Erstellt am: {{exportDate}}';
var HTML_EN = 'Hello, a new csv export was generated by the scheduled job {{exportTitle}} on {{exportDate}} Download:  <a href="{{downloadLink}}" target="_blank">{{exportTitle}} - {{exportDate}} </a>';
var HTML_DE = 'Hallo, ein neuer csv-Export von Exportzeitplan {{exportTitle}} vom {{exportDate}}  steht zum download bereit. Download: <a href="{{downloadLink}}" target="_blank">{{exportTitle}} - {{exportDate}}</a>';
export default {
  name: 'CoreCsvExportEmail',
  mixins: [iconsMixin],
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          emails: [''],
          selectedMailConnector: null,
          subject: localStorage.getItem('language') === 'en' ? SUBJECT_EN : SUBJECT_DE,
          html: localStorage.getItem('language') === 'en' ? HTML_EN : HTML_DE
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    mailConnectors: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      internalModel: _objectSpread({}, this.value)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    emailRules: function emailRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return /.+@.+\..+/.test(v) || _this.$i18n_t('Common.emailValid');
      }];
    },
    hasMailConnectors: function hasMailConnectors() {
      return this.mailConnectors && this.mailConnectors.length;
    }
  }),
  watch: {
    internalModel: {
      handler: function handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler: function handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = _objectSpread({}, this.value);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (!this.internalModel.subject) {
      this.internalModel.subject = localStorage.getItem('language') === 'en' ? SUBJECT_EN : SUBJECT_DE;
    }

    if (!this.internalModel.html) {
      this.internalModel.html = localStorage.getItem('language') === 'en' ? HTML_EN : HTML_DE;
    }

    this.emitInput();
  },
  methods: {
    emitInput: function emitInput() {
      this.$emit('input', _objectSpread(_objectSpread({}, this.internalModel), {}, {
        formIsValid: this.internalModel.selectedMailConnector && this.internalModel.emails && this.internalModel.emails.length && this.internalModel.emails.every(function (element) {
          return element && /.+@.+\..+/.test(element);
        }) && this.internalModel.subject && this.internalModel.html
      }));
    },
    addEmail: function addEmail(index) {
      this.internalModel.emails.splice(index + 1, 0, '');
    },
    removeEmail: function removeEmail(index) {
      if (this.internalModel.emails.length === 1) {
        this.internalModel.emails = [''];
        return;
      }

      this.internalModel.emails.splice(index, 1);
    }
  }
};